import { ReactElement } from 'react';

import { WaitlistEntryQuery, WaitlistEntryRestoreCommand } from '@dreryk/egabinet-waitlist-frontend-api';

import { Button, ButtonVariant, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

import { translationKeys } from '../../../translations';

type RestoreEntryButtonProps = {
   readonly entryId: number;
};

export const RestoreEntryButton = (props: RestoreEntryButtonProps): ReactElement => {
   const { executeAsync: restoreEntry } = useCqrsCommand<void, void>(
      () => {
         const command = new WaitlistEntryRestoreCommand();
         command.entryId = props.entryId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.successfullyRestoredToWaitlist);
            refetchCqrsQuery(WaitlistEntryQuery);
         },
      }
   );

   return (
      <Button
         label={translationKeys.restore}
         onClick={async () => restoreEntry()}
         variant={ButtonVariant.SECONDARY}
         compact
         testId={'restoreEntry'}
      />
   );
};
